export class Setting {
    public static OFFLINE_MODE:boolean = false;
    public static LOCAL_MODE: boolean = false;
    public static ALERT_TIMEOUT : number = 5000;
}